import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import FormSection from '../../FormComponents/FormSection';

import UserInfoIcon from '../../../img/formSectionIcons/userInfo.svg';
import useStyles from './makeStyles';

const ClaimSuccessTable = ({ claimSuccessData }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <FormSection title="personalInfo.header" icon={UserInfoIcon}>
      {
         claimSuccessData?.map((item) => (
           <React.Fragment key={uniqueId()}>
             <div className={classes.row}>
               <div
                 dangerouslySetInnerHTML={{
                   __html: t(item.title),
                 }}
               />
               <div className={classes.value}>{item.data}</div>
             </div>
             {item.divider && item.divider }
           </React.Fragment>
         ))
      }
    </FormSection>
  );
};

ClaimSuccessTable.propTypes = {
  claimSuccessData: PropTypes.arrayOf(PropTypes.shape({})),
};

ClaimSuccessTable.defaultProps = {
  claimSuccessData: undefined,
};

export default ClaimSuccessTable;
